import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try { await login(email, password); nav("/admin"); } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="admin-login-page">
      <div className="hidden lg:block relative"><img src="/images/hero.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" /><div className="absolute inset-0 bg-black/40" /></div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6">
          <img src="/brand/logo.png" alt="SoloRentaPC" className="h-28 mx-auto" />
          <div className="text-center"><h1 className="text-2xl font-bold">Panel administrativo</h1><p className="text-sm text-slate-500">Acceso privado</p></div>
          <Input type="email" required placeholder="Correo" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          <Input type="password" required placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <button disabled={busy} className="w-full rounded-full bg-[#FF3333] hover:bg-[#E62E2E] text-white font-semibold py-3 disabled:opacity-60" data-testid="login-submit-button">{busy ? "Entrando..." : "Entrar"}</button>
        </form>
      </div>
    </div>
  );
}
